import React from 'react'

/**
 * Decorative constellation behind the landing hero, ported verbatim from the
 * reference design. Pure ornament: no pointer events, hidden from assistive
 * technology, and it carries no information the copy does not already give.
 */
const HeroConstellation = () => (
  <svg
    className='mic-home-artwork'
    viewBox='0 0 1000 460'
    preserveAspectRatio='xMaxYMid slice'
    aria-hidden='true'
    focusable='false'
  >
    <g stroke='#4fd691' strokeWidth='.9' fill='none'>
      <line x1='914.3' y1='144.1' x2='912.1' y2='161.2' strokeOpacity='0.187' />
      <line x1='983.8' y1='32.4' x2='975.8' y2='16.9' strokeOpacity='0.192' />
      <line x1='418.5' y1='356.3' x2='433.8' y2='365.5' strokeOpacity='0.115'>
        <animate attributeName='stroke-opacity' values='0.115;0.265;0.115' dur='11s' repeatCount='indefinite' />
      </line>
      <line x1='745.2' y1='219.2' x2='732.4' y2='234.4' strokeOpacity='0.221' />
      <line x1='983.8' y1='32.4' x2='1003.3' y2='38.7' strokeOpacity='0.222' />
      <line x1='901.4' y1='377.3' x2='924.5' y2='367.4' strokeOpacity='0.133' />
      <line x1='872.7' y1='131.6' x2='874.1' y2='157.6' strokeOpacity='0.200' />
      <line x1='901.4' y1='377.3' x2='876.7' y2='367.9' strokeOpacity='0.132' />
      <line x1='872.7' y1='131.6' x2='844.7' y2='138.8' strokeOpacity='0.207' />
      <line x1='975.1' y1='50.8' x2='1003.3' y2='38.7' strokeOpacity='0.215' />
      <line x1='1009.5' y1='98.6' x2='976.4' y2='90.3' strokeOpacity='0.193' />
      <line x1='874.1' y1='157.6' x2='844.7' y2='138.8' strokeOpacity='0.194' />
      <line x1='975.8' y1='16.9' x2='1003.3' y2='38.7' strokeOpacity='0.182' />
      <line x1='753.4' y1='180.3' x2='746.1' y2='145.3' strokeOpacity='0.165'>
        <animate attributeName='stroke-opacity' values='0.165;0.379;0.165' dur='15s' repeatCount='indefinite' />
      </line>
      <line x1='529.9' y1='240.1' x2='565.7' y2='243.5' strokeOpacity='0.135' />
      <line x1='530.1' y1='252.0' x2='565.7' y2='243.5' strokeOpacity='0.143' />
      <line x1='874.1' y1='157.6' x2='912.1' y2='161.2' strokeOpacity='0.192' />
      <line x1='975.1' y1='50.8' x2='976.4' y2='90.3' strokeOpacity='0.238' />
      <line x1='753.4' y1='180.3' x2='745.2' y2='219.2' strokeOpacity='0.163' />
      <line x1='784.3' y1='125.9' x2='746.1' y2='145.3' strokeOpacity='0.164' />
      <line x1='914.3' y1='144.1' x2='872.7' y2='131.6' strokeOpacity='0.172' />
      <line x1='565.7' y1='243.5' x2='593.0' y2='279.9' strokeOpacity='0.140' />
      <line x1='587.8' y1='325.6' x2='593.0' y2='279.9' strokeOpacity='0.112' />
      <line x1='914.3' y1='144.1' x2='902.7' y2='190.3' strokeOpacity='0.170' />
      <line x1='732.4' y1='234.4' x2='687.3' y2='249.7' strokeOpacity='0.165'>
        <animate attributeName='stroke-opacity' values='0.165;0.379;0.165' dur='12s' repeatCount='indefinite' />
      </line>
      <line x1='876.7' y1='367.9' x2='924.5' y2='367.4' strokeOpacity='0.134' />
      <line x1='931.6' y1='317.9' x2='924.5' y2='367.4' strokeOpacity='0.133' />
      <line x1='874.0' y1='86.5' x2='922.6' y2='72.1' strokeOpacity='0.167' />
      <line x1='902.7' y1='190.3' x2='854.7' y2='210.5' strokeOpacity='0.243' />
      <line x1='922.6' y1='72.1' x2='975.1' y2='50.8' strokeOpacity='0.163' />
      <line x1='922.6' y1='72.1' x2='976.4' y2='90.3' strokeOpacity='0.163' />
      <line x1='983.8' y1='32.4' x2='976.4' y2='90.3' strokeOpacity='0.222' />
      <line x1='1009.5' y1='98.6' x2='975.1' y2='50.8' strokeOpacity='0.177' />
      <line x1='1009.5' y1='98.6' x2='1003.3' y2='38.7' strokeOpacity='0.176' />
      <line x1='217.6' y1='379.1' x2='167.1' y2='345.1' strokeOpacity='0.095' />
      <line x1='665.0' y1='192.7' x2='687.3' y2='249.7' strokeOpacity='0.143'>
        <animate attributeName='stroke-opacity' values='0.143;0.328;0.143' dur='9s' repeatCount='indefinite' />
      </line>
      <line x1='784.3' y1='125.9' x2='753.4' y2='180.3' strokeOpacity='0.151' />
      <line x1='745.2' y1='219.2' x2='687.3' y2='249.7' strokeOpacity='0.155' />
      <line x1='931.6' y1='317.9' x2='901.4' y2='377.3' strokeOpacity='0.118' />
      <line x1='914.3' y1='144.1' x2='874.0' y2='86.5' strokeOpacity='0.157' />
      <line x1='912.1' y1='161.2' x2='844.7' y2='138.8' strokeOpacity='0.179' />
      <line x1='874.1' y1='157.6' x2='874.0' y2='86.5' strokeOpacity='0.171' />
      <line x1='983.8' y1='32.4' x2='1009.5' y2='98.6' strokeOpacity='0.170' />
      <line x1='745.2' y1='219.2' x2='746.1' y2='145.3' strokeOpacity='0.148' />
      <line x1='931.6' y1='317.9' x2='876.7' y2='367.9' strokeOpacity='0.129' />
      <line x1='529.9' y1='240.1' x2='593.0' y2='279.9' strokeOpacity='0.120' />
      <line x1='922.6' y1='72.1' x2='975.8' y2='16.9' strokeOpacity='0.152'>
        <animate attributeName='stroke-opacity' values='0.152;0.350;0.152' dur='13s' repeatCount='indefinite' />
      </line>
      <line x1='912.1' y1='161.2' x2='874.0' y2='86.5' strokeOpacity='0.176' />
      <line x1='531.8' y1='392.6' x2='587.8' y2='325.6' strokeOpacity='0.100' />
      <line x1='217.6' y1='379.1' x2='304.9' y2='394.1' strokeOpacity='0.089' />
      <line x1='241.6' y1='468.7' x2='217.6' y2='379.1' strokeOpacity='0.088' />
      <line x1='530.1' y1='252.0' x2='587.8' y2='325.6' strokeOpacity='0.099' />
      <line x1='241.6' y1='468.7' x2='304.9' y2='394.1' strokeOpacity='0.100' />
      <line x1='531.8' y1='392.6' x2='433.8' y2='365.5' strokeOpacity='0.097' />
      <line x1='784.3' y1='125.9' x2='854.7' y2='210.5' strokeOpacity='0.133' />
      <line x1='418.5' y1='356.3' x2='531.8' y2='392.6' strokeOpacity='0.088' />
      <line x1='732.4' y1='234.4' x2='854.7' y2='210.5' strokeOpacity='0.150' />
      <line x1='241.6' y1='468.7' x2='167.1' y2='345.1' strokeOpacity='0.079'>
        <animate attributeName='stroke-opacity' values='0.079;0.181;0.079' dur='10s' repeatCount='indefinite' />
      </line>
      <line x1='167.1' y1='345.1' x2='304.9' y2='394.1' strokeOpacity='0.078' />
      <line x1='530.1' y1='252.0' x2='665.0' y2='192.7' strokeOpacity='0.102' />
      <line x1='433.8' y1='365.5' x2='530.1' y2='252.0' strokeOpacity='0.089' />
      <line x1='433.8' y1='365.5' x2='529.9' y2='240.1' strokeOpacity='0.086' />
      <line x1='418.5' y1='356.3' x2='529.9' y2='240.1' strokeOpacity='0.077' />
      <line x1='665.0' y1='192.7' x2='606.0' y2='41.9' strokeOpacity='0.094' />
      <line x1='418.5' y1='356.3' x2='587.8' y2='325.6' strokeOpacity='0.074' />
    </g>
    <g fill='#6ce2a8'>
      <circle cx='241.6' cy='468.7' r='3.4' fillOpacity='0.45' />
      <circle cx='217.6' cy='379.1' r='1.3' fillOpacity='0.22' />
      <circle cx='167.1' cy='345.1' r='3.7' fillOpacity='0.43'>
        <animate attributeName='fill-opacity' values='0.43;0.81;0.43' dur='10s' repeatCount='indefinite' />
      </circle>
      <circle cx='418.5' cy='356.3' r='4.8' fillOpacity='0.44' />
      <circle cx='531.8' cy='392.6' r='1.7' fillOpacity='0.24' />
      <circle cx='433.8' cy='365.5' r='4.7' fillOpacity='0.46' />
      <circle cx='304.9' cy='394.1' r='1.8' fillOpacity='0.26' />
      <circle cx='529.9' cy='240.1' r='2.6' fillOpacity='0.27' />
      <circle cx='530.1' cy='252.0' r='3.4' fillOpacity='0.50' />
      <circle cx='587.8' cy='325.6' r='1.4' fillOpacity='0.24'>
        <animate attributeName='fill-opacity' values='0.24;0.46;0.24' dur='11s' repeatCount='indefinite' />
      </circle>
      <circle cx='565.7' cy='243.5' r='1.8' fillOpacity='0.29' />
      <circle cx='593.0' cy='279.9' r='2.0' fillOpacity='0.31' />
      <circle cx='665.0' cy='192.7' r='1.4' fillOpacity='0.30' />
      <circle cx='784.3' cy='125.9' r='2.7' fillOpacity='0.33' />
      <circle cx='753.4' cy='180.3' r='1.8' fillOpacity='0.32' />
      <circle cx='745.2' cy='219.2' r='4.2' fillOpacity='0.59' />
      <circle cx='732.4' cy='234.4' r='1.3' fillOpacity='0.40'>
        <animate attributeName='fill-opacity' values='0.40;0.76;0.40' dur='12s' repeatCount='indefinite' />
      </circle>
      <circle cx='687.3' cy='249.7' r='2.5' fillOpacity='0.33' />
      <circle cx='914.3' cy='144.1' r='2.5' fillOpacity='0.34' />
      <circle cx='902.7' cy='190.3' r='2.4' fillOpacity='0.48' />
      <circle cx='872.7' cy='131.6' r='2.3' fillOpacity='0.47' />
      <circle cx='874.1' cy='157.6' r='2.2' fillOpacity='0.37' />
      <circle cx='912.1' cy='161.2' r='1.9' fillOpacity='0.47' />
      <circle cx='854.7' cy='210.5' r='1.8' fillOpacity='0.47'>
        <animate attributeName='fill-opacity' values='0.47;0.89;0.47' dur='13s' repeatCount='indefinite' />
      </circle>
      <circle cx='874.0' cy='86.5' r='3.7' fillOpacity='0.59' />
      <circle cx='922.6' cy='72.1' r='3.2' fillOpacity='0.54' />
      <circle cx='844.7' cy='138.8' r='2.1' fillOpacity='0.38' />
      <circle cx='983.8' cy='32.4' r='2.3' fillOpacity='0.48' />
      <circle cx='975.8' cy='16.9' r='1.8' fillOpacity='0.35' />
      <circle cx='1009.5' cy='98.6' r='4.5' fillOpacity='0.56' />
      <circle cx='975.1' cy='50.8' r='1.9' fillOpacity='0.45'>
        <animate attributeName='fill-opacity' values='0.45;0.86;0.45' dur='8s' repeatCount='indefinite' />
      </circle>
      <circle cx='1003.3' cy='38.7' r='2.0' fillOpacity='0.39' />
      <circle cx='976.4' cy='90.3' r='4.7' fillOpacity='0.64' />
      <circle cx='746.1' cy='145.3' r='2.3' fillOpacity='0.32' />
      <circle cx='644.4' cy='-14.8' r='2.6' fillOpacity='0.36' />
      <circle cx='606.0' cy='41.9' r='2.1' fillOpacity='0.30' />
      <circle cx='931.6' cy='317.9' r='2.6' fillOpacity='0.30' />
      <circle cx='901.4' cy='377.3' r='1.7' fillOpacity='0.26'>
        <animate attributeName='fill-opacity' values='0.26;0.50;0.26' dur='9s' repeatCount='indefinite' />
      </circle>
      <circle cx='876.7' cy='367.9' r='2.2' fillOpacity='0.29' />
      <circle cx='924.5' cy='367.4' r='1.4' fillOpacity='0.28' />
    </g>
  </svg>
)

export default HeroConstellation
